<!-- Header -->
<app-patient-header [member]="member" [showHeader]="showHeader" [type]="'case'"></app-patient-header>
<app-flag-list [caseId]="id" [memberId]=""></app-flag-list>

<!-- Body -->
<kendo-splitter #splitter orientation="horizontal" style="background-color:#f5f6fb; border: none;"
  (layoutChange)="updateSplitterBar()">
  <kendo-splitter-pane>
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
      <kendo-tabstrip-tab title="{{ 'SUMMARY' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-0">
            <app-case-detail-summary *ngIf="member" [id]="id" [data]="model" [member]="member" #caseDetailSummary>
            </app-case-detail-summary>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Notes-->
      <kendo-tabstrip-tab *ngIf="notesEnabled">
        <ng-template kendoTabTitle>
          {{ 'NOTES' | translate }}
          <span *ngIf="tabCounts?.notes > 0" class="badge badge-pill badge-counts">{{tabCounts?.notes}}</span>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-0">
            <div class="row mt-2">
              <div class="col-sm-12">
                <app-notes-list-section [caseId]="id" (refresh)="getCaseCountTabs()"></app-notes-list-section>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Contacts-->
      <kendo-tabstrip-tab *ngIf="contactsEnabled">
        <ng-template kendoTabTitle>
          {{ 'CONTACT-HISTORY' | translate }}
          <span *ngIf="tabCounts?.contacts > 0" class="badge badge-pill badge-counts">{{tabCounts?.contacts}}</span>
        </ng-template>
        <ng-template kendoTabContent>
          <!-- Contact History -->
          <div class="content-background pl-3 pr-3 pt-0">
            <div class="row mt-2">
              <div class="col-sm-12">
                <app-contact-history-section *ngIf="member" [memberId]="member.id" (refresh)="getCaseCountTabs()">
                </app-contact-history-section>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Appointments-->
      <kendo-tabstrip-tab *ngIf="appointmentsEnabled">
        <ng-template kendoTabTitle>
          {{ 'APPOINTMENTS' | translate }}
          <span *ngIf="tabCounts?.appointments > 0"
            class="badge badge-pill badge-counts">{{tabCounts?.appointments}}</span>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-0">
            <div class="row mt-2">
              <div class="col-sm-12">
                <app-appointment-list-section [memberId]="member.id" (refresh)="getCaseCountTabs()">
                </app-appointment-list-section>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Events-->
      <kendo-tabstrip-tab *ngIf="eventsEnabled">
        <ng-template kendoTabTitle>
          {{ 'EVENTS' | translate }}
          <span *ngIf="tabCounts?.events > 0" class="badge badge-pill badge-counts">{{tabCounts?.events +
            tabCounts?.appointments}}</span>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-0">
            <app-case-detail-event [model]="model" [member]="member"></app-case-detail-event>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Case extensions-->
      <kendo-tabstrip-tab title="{{ 'EXTENSIONS' | translate }}"
        *ngIf="(caseExtensionsEnabled && viewExtensions?.gridData?.total > 0) || caseExtensionsEditable">
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-2">
            <kendo-grid [data]="viewExtensions.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
              [sort]="viewExtensions.state.sort" [resizable]="true" [selectable]="{mode: 'single'}"
              [kendoGridSelectBy]="'id'" (add)="caseExtensionAddHandler($event)"
              (edit)="caseExtensionEditHandler($event)" (save)="saveCaseExtension($event)"
              (cancel)="viewExtensions.cancelHandler($event)" (dataStateChange)="extensionsDataStateChange($event)">
              <kendo-grid-messages noRecords="{{ 'NO-CASE-EXTENSIONS' | translate }}">
              </kendo-grid-messages>
              <!--Organization Name -->
              <kendo-grid-column field="settingExtension.organization.name"
                title="{{ 'SOURCE-ORGANIZATION' | translate }}" [width]="50" [filterable]="false" [sortable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span
                    *ngIf="dataItem.settingExtension.organization">{{dataItem.settingExtension.organization.name}}</span>
                </ng-template>
                <ng-template kendoGridEditTemplate>
                  <div [formGroup]="caseExtensionFormGroup">
                    <kendo-combobox id="organization" formControlName="organization" [data]="organizations"
                      [textField]="'name'" [valueField]="'id'" (valueChange)="organizationChange(true)"
                      [readonly]="!isOperatorRole">
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <span
                          [ngClass]="{'font-weight-bold': isOrganizationHasExtension(dataItem.id)}">{{dataItem.name}}</span>
                      </ng-template>
                    </kendo-combobox>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!--Extension Name-->
              <kendo-grid-column field="settingExtension.name" [width]="50" title="{{ 'NAME' | translate }}"
                [filterable]="false" [sortable]="true">
                <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="caseExtensionFormGroup">
                  <kendo-dropdownlist [data]="extensionsByCategoryAndOrganizationUnused" textField="name"
                    valueField="id" [valuePrimitive]="false"
                    [formControl]="caseExtensionFormGroup.get('settingExtension')">
                  </kendo-dropdownlist>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span title="{{dataItem.displayLabel}}"
                    *ngIf="dataItem.settingExtension">{{dataItem.settingExtension.name}}
                  </span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="value" [width]="40" title="{{ 'VALUE' | translate }}">
                <ng-template kendoGridEditTemplate>
                  <div [formGroup]="caseExtensionFormGroup">
                    <input kendoTextBox formControlName="value" maxlength="10485760" />
                  </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span *ngIf="dataItem.value">{{formatExtensionValue(dataItem)}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column *ngIf="viewExtensionsShowAlternateValue" field="alternateValue" [width]="40"
                title="{{ 'ALTERNATE-VALUE' | translate }}">
              </kendo-grid-column>
              <kendo-grid-column *ngIf="viewExtensionsShowDisplayName" field="displayName" [width]="65"
                title="{{ 'DISPLAY-NAME' | translate }}">
              </kendo-grid-column>
              <kendo-grid-command-column [width]="20" title="{{ 'ACTIONS' | translate }}" class="text-center"
                *ngIf="caseExtensionsEditable">
                <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
                  <ng-container *ngIf="!dataItem.editing">
                    <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                      (click)="caseExtensionEditButton.click.emit($event); dataItem.editing = true;"></i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                      (click)="openDeleteCaseExtensionDialog(dataItem)"></i>
                    <button kendoGridEditCommand #caseExtensionEditButton class="d-none"></button>
                  </ng-container>
                  <ng-container *ngIf="dataItem.editing">
                    <ng-container *ngIf="caseExtensionFormGroup.valid">
                      <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                        (click)="caseExtensionSaveButton.click.emit($event); dataItem.editing = false;">
                      </i>
                      &nbsp;
                    </ng-container>
                    <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                      (click)="caseExtensionCancelButton.click.emit($event); dataItem.editing = false;"></i>
                    <button kendoGridSaveCommand #caseExtensionSaveButton class="d-none"></button>
                    <button kendoGridCancelCommand #caseExtensionCancelButton class="d-none"></button>
                  </ng-container>
                </ng-template>
              </kendo-grid-command-column>
              <button kendoGridAddCommand #caseExtensionAddButton class="d-none"></button>
            </kendo-grid>
            <button kendoButton *ngIf="caseExtensionsEditable" type="button" class="float-right mt-3 mb-3"
              (click)="caseExtensionAddButton.click.emit($event)">
              {{'ADD' | translate}}<i class="far fa-plus"></i>
            </button>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Billable Items-->
      <kendo-tabstrip-tab title="{{'BILLABLES' | translate}}" *ngIf="viewBillableItems.data.length > 0">
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-2">
            <div class="row">
              <div class="col-sm-12">
                <div class="inputWithIcon inputWithIcon-search float-right d-flex mb-2">
                  <app-advanced-mode id="accumulatorGridAdvancedSwitch" [storageKey]="'billables-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                  </app-advanced-mode>
                </div>
              </div>
            </div>
            <kendo-grid [data]="viewBillableItems.gridData" [loading]="viewBillableItems.loading"
              [pageable]="billablesCount > viewBillableItems.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
              [pageSize]="viewBillableItems.state.take" [skip]="viewBillableItems.state.skip" [sortable]="true"
              [sort]="viewBillableItems.state.sort" [filterable]="enableAdvanced"
              [filter]="viewBillableItems.state.filter" [groupable]="false" [selectable]="{mode: 'single'}"
              [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced" [kendoGridSelectBy]="'id'"
              (edit)="caseBillableEditHandler($event)" (save)="saveCaseBillable($event)"
              (cancel)="caseBillableCancelHandler($event)" (dataStateChange)="billableItemsDataStateChange($event)">
              <!--Billable Name -->
              <kendo-grid-column field="billableName" title="{{ 'NAME' | translate }}" [width]="25" [filterable]="true"
                [sortable]="true">
              </kendo-grid-column>
              <!--Date of Service-->
              <kendo-grid-column field="billableDate" title="{{ 'DATE-OF-SERVICE' | translate }}" [width]="20"
                filter="date" format="{0:d}">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div *ngIf="dataItem.billableDate !== null && dataItem.billableDate !== undefined"
                    class="text-center">
                    {{ intl.formatDate(intl.parseDate(dataItem.billableDate), "d") }}
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!--Service Code-->
              <kendo-grid-column field="serviceCode" title="{{ 'RATE-CODE' | translate }}" [width]="20"
                [filterable]="true" [sortable]="true">
              </kendo-grid-column>
              <!--Modifiers-->
              <kendo-grid-column field="modifierCodes" title="{{ 'MODIFIERS' | translate }}" [width]="20"
                [filterable]="true" [sortable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span *ngIf="dataItem.modifierCode">{{dataItem.modifierCode}}</span><span
                    *ngIf="dataItem.modifierCode2"><span
                      *ngIf="dataItem.modifierCode">,&nbsp;</span>{{dataItem.modifierCode2}}</span><span
                    *ngIf="dataItem.modifierCode3"><span
                      *ngIf="dataItem.modifierCode2">,&nbsp;</span>{{dataItem.modifierCode3}}</span>
                </ng-template>
              </kendo-grid-column>
              <!--Units-->
              <kendo-grid-column field="units" title="{{ 'UNITS' | translate }}" [width]="20" class="text-right"
                filter="numeric">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span
                    *ngIf="!dataItem.billableServiceHasManualAmount && dataItem.units !== 0">{{dataItem.units}}</span>
                  <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.units}}</span>
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                  <div [formGroup]="caseBillableFormGroup">
                    <kendo-numerictextbox [format]="'n0'" formControlName="units" [min]="1" style="max-width:150px">
                    </kendo-numerictextbox>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!--Rate-->
              <kendo-grid-column field="rate" title="{{ 'RATE' | translate }}" [width]="25" [filterable]="true"
                [sortable]="true" [format]="'n2'" class="text-right" filter="numeric">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span *ngIf="!dataItem.billableServiceHasManualAmount">{{dataItem.rate | number : '1.2-2'}}</span>
                  <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.rate | number : '1.2-2'}}</span>
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                  <div [ngSwitch]="!dataItem.billableServiceHasManualAmount">
                    <div *ngSwitchCase="true" [formGroup]="caseBillableFormGroup">
                      <kendo-numerictextbox [format]="'n2'" formControlName="rate" [min]="0" style="max-width:150px">
                      </kendo-numerictextbox>
                    </div>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!--Amount-->
              <kendo-grid-column field="amount" title="{{ 'BILLED-AMOUNT' | translate }}" [width]="25" [format]="'n2'"
                class="text-right" filter="numeric">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.amount | number : '1.2-2'}}</span>
                  <span *ngIf="!dataItem.billableServiceHasManualAmount">{{dataItem.amount | number : '1.2-2'}}</span>
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                  <div [ngSwitch]="dataItem.billableServiceHasManualAmount">
                    <div *ngSwitchCase="true" [formGroup]="caseBillableFormGroup">
                      <kendo-numerictextbox [format]="'n2'" formControlName="amount" [min]="0" style="max-width:150px">
                      </kendo-numerictextbox>
                    </div>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!--Diagnoses-->
              <kendo-grid-column field="diagnoses" title="{{ 'DIAGNOSES' | translate }}" [width]="25"
                [filterable]="true" [sortable]="true">
              </kendo-grid-column>
              <!--Status-->
              <kendo-grid-column field="caseBillableStatus" title="{{ 'STATUS' | translate }}" [width]="25"
                [filterable]="true" [sortable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="text-center">
                    {{getCaseBillableText(dataItem.caseBillableStatus)}}
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!--Remark-->
              <kendo-grid-column-group title="{{ 'REMARK' | translate }}">
                <!--Remark Code-->
                <kendo-grid-column field="remarkCode" title="{{ 'CODE' | translate }}" [width]="25" [filterable]="true"
                  [sortable]="true">
                </kendo-grid-column>
                <!--Remark Description-->
                <kendo-grid-column field="remarkDescription" title="{{ 'DESCRIPTION' | translate }}" [width]="25"
                  [filterable]="true" [sortable]="true">
                </kendo-grid-column>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span *ngIf="dataItem.remarkCode">{{ dataItem.remarkCode }}</span>
                  <p *ngIf="dataItem.remarkDescription">{{ dataItem.remarkDescription }}</p>
                </ng-template>
              </kendo-grid-column-group>
              <!--Org Payment Status-->
              <kendo-grid-column field="orgPaymentStatus.displayName" title="{{ 'ORG-PAYMENT-STATUS' | translate }}"
                [width]="25" [filterable]="true" [sortable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="text-center">
                    {{dataItem.orgPaymentStatus.displayName}}
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!--Organization-->
              <kendo-grid-column field="organizationName" title="{{ 'ORGANIZATION' | translate }}" [width]="25" [filterable]="true"
                [sortable]="true">
              </kendo-grid-column>
              <kendo-grid-command-column [width]="20" title="{{ 'ACTIONS' | translate }}" class="text-center"
                *ngIf="isOperatorRole && caseBillableActionsVisible">
                <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
                  <ng-container *ngIf="!dataItem.editing">
                    <i class="fas fa-edit fa-lg"
                      *ngIf="!dataItem.caseBillableUsedInInvoice && !dataItem.billableServiceInformationalOnly"
                      title="{{'EDIT' | translate}}"
                      (click)="caseBillableEditButton.click.emit($event); dataItem.editing = true;"></i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg"
                      [ngClass]="{'extra-spacing': dataItem.billableServiceInformationalOnly}"
                      *ngIf="dataItem.caseBillableStatus !== 'PAID' && !dataItem.caseBillableUsedInInvoice"
                      title="{{'DELETE' | translate}}" (click)="openDeleteCaseBillableDialog(dataItem)"></i>
                    <button kendoGridEditCommand #caseBillableEditButton class="d-none"></button>
                  </ng-container>
                  <ng-container *ngIf="dataItem.editing">
                    <ng-container *ngIf="caseBillableFormGroup.valid">
                      <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                        (click)="caseBillableSaveButton.click.emit($event); dataItem.editing = false;">
                      </i>
                      &nbsp;
                    </ng-container>
                    <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                      (click)="caseBillableCancelButton.click.emit($event); dataItem.editing = false;"></i>
                    <button kendoGridSaveCommand #caseBillableSaveButton class="d-none"></button>
                    <button kendoGridCancelCommand #caseBillableCancelButton class="d-none"></button>
                  </ng-container>
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </kendo-splitter-pane>
  <kendo-splitter-pane
    *ngIf="!isBillablesTabSelected && (caseHistoryEnabled || caseCareTeamsEnabled || patientCareTeamsEnabled || (communityEnabled && pinnedResourcesEnabled))"
    [(size)]="rightPaneSize" [collapsible]="true" min="420px" [resizable]="true" class="pt-0"
    [ngClass]="{'content-background ': !paneCollapsed }" (collapsedChange)="collapseChange($event)">
    <!-- Case History-->
    <div *ngIf="caseHistoryEnabled">
      <hr>
      <h6 class="text-uppercase collapsible-text" (click)="caseHistoriesCollapsible.toggleChange()">{{'CASE-HISTORY' |
        translate}}
        <app-collapsible #caseHistoriesCollapsible [storageKey]="'case-histories'"
          (collapsibleToggle)="caseHistoriesCollapsed=$event">
        </app-collapsible>
      </h6>
      <div *ngIf="!caseHistoriesCollapsed" style="max-height: 400px; overflow-y: auto; overflow-x: hidden;">
        <app-case-history [entries]=displayedHistoryEvents></app-case-history>
      </div>
    </div>
    <!-- Team -->
    <div class="mt-4" *ngIf="caseCareTeamsEnabled">
      <app-team-list *ngIf="member && !switchingCaseContext" [caseId]="id" [memberId]="member.id"
        (assigned)="getCaseDetailsData()" (addTask)="caseDetailSummary.createTask($event)"
        (modifyTeam)="caseDetailSummary.updateTasks($event)">
      </app-team-list>
    </div>
    <div class="mt-4" *ngIf="patientCareTeamsEnabled">
      <div>
        <app-team-list *ngIf="member" [caseId]="" [memberId]="member.id"
          (addTask)="caseDetailSummary.createTask($event)">
        </app-team-list>
      </div>
    </div>
    <!--Pinned Resources-->
    <div class="mt-4" *ngIf="communityEnabled && pinnedResourcesEnabled && memberId && memberId > 0">
      <hr>
      <h6 class="text-uppercase collapsible-text" (click)="pinnedResourcesCollapsible.toggleChange()">{{
        'PINNED-RESOURCES' | translate}}&nbsp;
        <app-collapsible #pinnedResourcesCollapsible [storageKey]="'case-pinned-resources'"
          (collapsibleToggle)="patientPinnedResourcesCollapsed=$event">
        </app-collapsible>
      </h6>
      <div *ngIf="!patientPinnedResourcesCollapsed">
        <app-pinned-resource-list [memberId]="memberId"></app-pinned-resource-list>
      </div>
    </div>
  </kendo-splitter-pane>
</kendo-splitter>

<!-- delete case extension confirmation dialog -->
<kendo-dialog *ngIf="caseExtensionDeleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
  (close)="caseExtensionDeleteDialogOpened = false">
  <p>{{'CONFIRM-CASE-EXTENSION-DELETION' | translate}}</p>
  <div>
    <span
      class="k-font-weight-bold">{{selectedCaseExtension.settingExtension.organization.name}}&nbsp;-&nbsp;{{selectedCaseExtension.settingExtension.name}}</span>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="caseExtensionDeleteDialogOpened = false">{{'NO' | translate}}</button>
    <button kendoButton (click)="deleteCaseExtension(selectedCaseExtension)" [disabled]="errorMessage">{{'YES' |
      translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- delete case billable confirmation dialog -->
<kendo-dialog *ngIf="caseBillableDeleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
  (close)="caseBillableDeleteDialogOpened = false">
  <p>{{'CONFIRM-CASE-BILLABLE-DELETION' | translate}}</p>
  <div>
    <span
      class="k-font-weight-bold">{{selectedCaseBillable.billableName}}&nbsp;-&nbsp;{{getCaseBillableText(selectedCaseBillable.caseBillableStatus)}}</span>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="caseBillableDeleteDialogOpened = false">{{'NO' | translate}}</button>
    <button kendoButton (click)="deleteCaseBillable(selectedCaseBillable)" [disabled]="errorMessage">{{'YES' |
      translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>